import BaseEntity from './base/BaseEntity.model';

export default class Direccion extends BaseEntity{
    public latitude?: number;
    public longitude? : number; 
    public descripcion? : string;
    public no? : string;
    public referencia? : string;
    public calleStr? : string;
    public codSubBarrio? : string;
    public codBarrio?: string
    public barrioNombre?  : string
    public codSeccion?: string
    public seccionNombre?  : string
    public codDistritoMunicipal?: string;
    public distritoMunicipalNombre? : string;
    public codMunicipio?: string;
    public municipioNombre? : string;
    public codProvincia?  : string;
    public provinciaNombre?  : string;
    public codRegion?: string;
    public regionNombre?  : string;
    public subBarrioId?: number;
    public barrioId?: number;
    public distritoMunicipalId?: number;
    public municipioId?: number;
    public seccionId?: number;
    public provinciaId?: number;
    public regionId?: number;
}